var map = {
	"./aluminum.svg": 50406,
	"./copper.svg": 34380,
	"./gold.svg": 83730,
	"./lead.svg": 34930,
	"./ngas.svg": 34273,
	"./nickel.svg": 54306,
	"./palladium.svg": 97117,
	"./platinum.svg": 49864,
	"./silver.svg": 11675,
	"./ukoil.svg": 91220,
	"./usoil.svg": 99452,
	"./zinc.svg": 52914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61970;